import React, { useState } from 'react';
import { useIntl } from '../../util/reactIntl';
import { languagesHelper as language } from '../../util/languages';
import { IconArrowHead } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionSeasonalAvailability = props => {
  const { title, publicData, config } = props;
  const listingType = publicData?.listingType;
  const field_season = publicData?.field_season;

  if (!field_season?.length || listingType === 'negotiation-type-regular' || listingType === 'listing-type-multiday-fix-dates') return null

  const [showSection, setShowSection] = useState(true);

  const allMonth = config?.listing?.listingFields?.find(f => f.key === "field_season")?.enumOptions;
  const intl = useIntl();

  return (
    <section className={css.section}>
      <h2 className={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        {title}
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </h2>

      {showSection && (
        <div className={css.month}>
          {allMonth.map(m => {
            const isActive = field_season.includes(m.option);
            return (
              <div
                key={m.option}
                className={classNames(css.monthItem, isActive && css.monthItemActive)}
              >
                {language.labelsTranslator(m.option, intl)}
              </div>
            )
          })}
        </div>
      )}
    </section>
  );
};

export default SectionSeasonalAvailability;
